module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-section"
  }, [_c('h3', {
    staticClass: "section-title teko white"
  }, [_vm._v("\n      How to use\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "wrap-code text-left"
  }, [_c('h4', {
    staticClass: "white"
  }, [_vm._v("\n        App.vue file - Simple example\n      ")]), _vm._v(" "), _c('pre', {
    staticClass: "language-html"
  }, [_c('code', [_vm._v("\n" + _vm._s(_vm.appCode) + "\n        ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "wrap-code text-left"
  }, [_c('h4', {
    staticClass: "white"
  }, [_vm._v("\n        App.vue file - Full example\n      ")]), _vm._v(" "), _c('pre', {
    staticClass: "language-html"
  }, [_c('code', [_vm._v("\n" + _vm._s(_vm.appCodeFull) + "\n        ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "npm-code white"
  }, [_vm._v("              "), _c('code', [_vm._v("\nnpm install vue-particles --save-dev\n              ")]), _vm._v("\n     ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap-code text-left"
  }, [_c('h4', {
    staticClass: "white"
  }, [_vm._v("\n        Main.js file\n      ")]), _vm._v(" "), _c('pre', {
    staticClass: "language-js"
  }, [_c('code', [_vm._v("\nimport Vue from 'vue'\nimport VueParticles from 'vue-particles'\nVue.use(VueParticles)\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap-table"
  }, [_c('h4', {
    staticClass: "white text-left"
  }, [_vm._v("\n       Props\n      ")]), _vm._v(" "), _c('table', {
    staticClass: "rwd-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Description")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("color")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("#dedede")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("Particle color")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("particleOpacity")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("Number")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("0.7")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("Particle opacity")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("particlesNumber")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("Number")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("80")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("Amount of particles")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("shapeType")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("\"circle\"")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("\n            Available shape types: \"circle\",\"edge\",\"triangle\",\n            \"polygon\",\"star\"\n          ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("particleSize")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("Number")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("\n            Size of single particle\n          ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("linesColor")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("#dedede")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("\n            Lines color\n          ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("linesWidth")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("Number")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("\n            Lines width\n          ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("lineLinked")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("Boolean")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("true")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("\n            Enable lines\n          ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("lineOpacity")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("Number")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("0.4")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("\n            Line opacity\n          ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("linesDistance")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("Number")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("150")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("\n            Lines distance\n          ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("moveSpeed")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("Number")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("\n            Particles speed\n          ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("hoverEffect")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("Boolean")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("true")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("\n            Enable hover effect\n          ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("hoverMode")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("grab")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("\n            Available hover modes:\n            \"grab\", \"repulse\", \"bubble\"\n          ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("clickEffect")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("Boolean")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("true")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("\n            Enable click effect\n          ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("clickMode")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("push")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("\n            Available click modes:\n            \"push\", \"remove\", \"repulse\", \"bubble\"\n          ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02c74d78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
// module id = 24
// module chunks = 0